import { FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import {
  ButtonSave,
  ButtonSaveTitleSmall,
  FormSettingBlock,
  FormSettingButtons,
  FormSettingStyledListItem,
  TimeRangeContainer,
  TimeRangeInput,
  TimeRangeLabel,
} from './style';
import { FormattedMessage } from 'react-intl';

interface ChatSettingsProps {
  chatCutoffPeriod: {
    start: string;
    end: string;
  };
  setChatCutoffPeriod: (
    value: React.SetStateAction<{
      start: string;
      end: string;
    }>,
  ) => void;
  chatSessionEndTime: string;
  setChatSessionEndTime: (value: React.SetStateAction<string>) => void;
  onSave: () => Promise<void>;
}

const ChatSettings: React.FC<ChatSettingsProps> = ({
  chatCutoffPeriod,
  setChatCutoffPeriod,
  chatSessionEndTime,
  setChatSessionEndTime,
  onSave,
}) => (
  <FormSettingButtons>
    <FormSettingBlock>
      <FormSettingStyledListItem>
        <Typography fontSize={'medium'}>
          <FormattedMessage
            id="storeDetails.chatSettings.cutofftime.label"
            defaultMessage="Chat Cut Off Period"
          />
        </Typography>
        <FormControl sx={{ minWidth: 120 }}>
          <TimeRangeContainer>
            <TimeRangeLabel>From: </TimeRangeLabel>
            <TimeRangeInput
              id="chat-cutoff-period-start"
              type="time"
              name="chat-cutoff-period-start"
              value={chatCutoffPeriod.start}
              onChange={(e) => setChatCutoffPeriod((prev) => ({ ...prev, start: e.target.value }))}
            />
            <TimeRangeLabel>Till: </TimeRangeLabel>
            <TimeRangeInput
              id="chat-cutoff-period-end"
              type="time"
              name="chat-cutoff-period-end"
              value={chatCutoffPeriod.end}
              onChange={(e) => setChatCutoffPeriod((prev) => ({ ...prev, end: e.target.value }))}
            />
          </TimeRangeContainer>
          <FormHelperText>
            <FormattedMessage
              id="storeDetails.chatSettings.cutofftime.helpertext"
              defaultMessage="Time period when agents should off duty"
            />
          </FormHelperText>
        </FormControl>
      </FormSettingStyledListItem>
      <FormSettingStyledListItem>
        <Typography fontSize={'medium'}>
          <FormattedMessage
            id="storeDetails.chatSettings.sessionEndTime.label"
            defaultMessage="Chat Session End Time"
          />
        </Typography>
        <FormControl sx={{ minWidth: 120 }}>
          <Select
            id="chat-session-end-time"
            value={chatSessionEndTime}
            inputProps={{ 'aria-label': 'without label' }}
            onChange={(e) => setChatSessionEndTime(e.target.value)}
          >
            {Array.from({ length: 24 }, (_, i) => i + 1).map((hour) => (
              <MenuItem key={hour} value={String(hour * 3600)}>
                {hour} {hour === 1 ? 'hour' : 'hours'}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            <FormattedMessage
              id="storeDetails.chatSettings.sessionEndTime.helpertext"
              defaultMessage="how long until a chat is considered a new session"
            />
          </FormHelperText>
        </FormControl>
      </FormSettingStyledListItem>
    </FormSettingBlock>
    <FormSettingBlock>
      <ButtonSaveTitleSmall>
        <ButtonSave onClick={onSave}>
          <FormattedMessage
            id="storeDetails.chatSettings.save.label"
            defaultMessage="Update Chat Setting"
          />
        </ButtonSave>
      </ButtonSaveTitleSmall>
    </FormSettingBlock>
  </FormSettingButtons>
);

export default ChatSettings;
